import { createContext } from 'react';
import { useLocation } from 'react-router-dom';

import {
  SetSearchParamsOverride,
  useStateFromSearchParams,
} from '@/hooks/useStateFromSearchParams';
import { appGraphIndexPath } from '@/utils/constants';

export enum StudioRenderMode {
  INTERACT = 'interact',
  TRACE = 'trace',
}

export const useStudioRenderMode = (
  setSearchParams?: SetSearchParamsOverride
) => {
  const location = useLocation();
  const isGraphPage = location.pathname.includes(appGraphIndexPath);

  const defaultRenderMode = isGraphPage ? StudioRenderMode.INTERACT : '';

  const [renderMode, setRenderMode] = useStateFromSearchParams(
    'render',
    defaultRenderMode,
    setSearchParams
  );

  return {
    renderMode: renderMode as StudioRenderMode,
    setRenderMode,
  };
};

export const StudioRenderModeContext = createContext<{
  renderMode: StudioRenderMode;
  setRenderMode: (mode: StudioRenderMode) => void;
}>({
  renderMode: StudioRenderMode.INTERACT,
  setRenderMode: () => {},
});
